import { memo } from "react";

import { CustomEventsEsmAlert } from "./CustomEventsEsmAlert";
import {
  HeadlessDeprecatedAlert,
  HeadlessMissingAlert,
  HeadlessOutdatedAlert,
} from "./HeadlessAlerts";
import { MissingShopifyOrgIdAlert, ShopifyPermissionsAlert } from "./OrgAlerts";
import {
  ScriptIncompleteAlert,
  ScriptIncorrectAlert,
  ScriptMissingAlert,
  ScriptMultipleAlert,
  ScriptMultipleWithAppEmbedAlert,
  ScriptOutdatedAlert,
} from "./ScriptAlerts";
import { SystemStatusAlert } from "./SystemStatusAlert";
import { AlertRendererProps } from "./types";

export const AlertRenderer = memo(function AlertRenderer({
  alertType,
  orgId,
  shopId,
  scriptStatusExpected,
  scriptStatusFound,
  additionalAlert,
  endContent,
  systemAlert,
}: AlertRendererProps) {
  switch (alertType) {
    case "systemStatus":
      return (
        <SystemStatusAlert
          additionalAlert={additionalAlert}
          endContent={endContent}
          systemAlert={systemAlert}
        />
      );
    case "missingShopifyOrgId":
      return (
        <MissingShopifyOrgIdAlert
          additionalAlert={additionalAlert}
          endContent={endContent}
        />
      );
    case "scriptMissing":
      return (
        <ScriptMissingAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          endContent={endContent}
        />
      );
    case "scriptOutdated":
      return (
        <ScriptOutdatedAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          endContent={endContent}
        />
      );
    case "scriptIncomplete":
      return (
        <ScriptIncompleteAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          endContent={endContent}
        />
      );
    case "scriptMultipleWithAppEmbed":
      return (
        <ScriptMultipleWithAppEmbedAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          shopId={shopId}
          endContent={endContent}
        />
      );
    case "scriptMultiple":
      return (
        <ScriptMultipleAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          shopId={shopId}
          endContent={endContent}
        />
      );
    case "scriptIncorrect":
      return (
        <ScriptIncorrectAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          expected={scriptStatusExpected}
          found={scriptStatusFound}
          endContent={endContent}
        />
      );
    case "headlessMissing":
      return (
        <HeadlessMissingAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          endContent={endContent}
        />
      );
    case "headlessDeprecated":
      return (
        <HeadlessDeprecatedAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          expected={scriptStatusExpected}
          found={scriptStatusFound}
          endContent={endContent}
        />
      );
    case "headlessOutdated":
      return (
        <HeadlessOutdatedAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          expected={scriptStatusExpected}
          found={scriptStatusFound}
          endContent={endContent}
        />
      );
    case "shopifyPermissions":
      return (
        <ShopifyPermissionsAlert
          additionalAlert={additionalAlert}
          endContent={endContent}
        />
      );
    case "customEventsEsm":
      return (
        <CustomEventsEsmAlert
          additionalAlert={additionalAlert}
          orgId={orgId}
          endContent={endContent}
        />
      );
    default:
      return null;
  }
});
